export default __webpack_public_path__ + "static/agent3-fda6b54cbb1ea4c3407e9a20833a2c91.png";